import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { 
  FaUsers, 
  FaGlobeAmericas, 
  FaMoneyBillWave 
} from 'react-icons/fa';
import './../assets/styles/EngagementOptionsServiceDetails.css';

const EngagementOptions = () => {
  const options = [
    {
      id: 1,
      title: "Dedicated Team",
      description: "Fast-track your projects with our team of technical and management experts through collaborative efforts.",
      icon: <FaUsers size={40} />,
      cta: "Partner with Specialists →",
      path: "/dedicated-team"
    },
    {
      id: 2,
      title: "Offshore Development",
      description: "Access to top 2% of technical experts providing stability and scalability of projects with reduced time-to-market.",
      icon: <FaGlobeAmericas size={40} />,
      cta: "Engage Our Expert Team →",
      path: "/offshore-development"
    },
    {
      id: 3,
      title: "Fixed Price Projects",
      description: "Optimize your projects with minimum risks, assuring quality and on-time/on-budget delivery.",
      icon: <FaMoneyBillWave size={40} />,
      cta: "Get a Fixed Price Estimate →",
      path: "/fixed-price"
    }
  ];

  return (
    <section className="engagement">
      <Container>
        <h1 className="engagement-title">How Can We Engage?</h1>
        
        <Row className="engagement-row">
          {options.map((option) => (
            <Col key={option.id} lg={4} md={6} sm={12}>
              <Card className="engagement-card h-100">
                <div className="engagement-card-icon">
                  {option.icon}
                </div>
                <Card.Body>
                  <h3 className="engagement-card-title">{option.title}</h3>
                  <p className="engagement-card-text">{option.description}</p>
                  <button className='engagement-button'><a href={option.path} className="engagement-card-link">{option.cta}</a></button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default EngagementOptions;